var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCancel = function SvgCancel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.1 500 991.7 48.4c11.1-11.1 11.1-29 0-40.1s-29-11.1-40.1 0L500 459.9 48.4 8.3c-11.1-11.1-29-11.1-40.1 0s-11.1 29 0 40.1L459.9 500 8.3 951.6c-11.1 11.1-11.1 29 0 40.1 5.5 5.5 12.8 8.3 20.1 8.3s14.5-2.8 20.1-8.3L500 540.1l451.6 451.6c5.5 5.5 12.8 8.3 20.1 8.3s14.5-2.8 20.1-8.3c11.1-11.1 11.1-29 0-40.1z",
    className: "cancel_svg__cancelSt01"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCancel);
export default ForwardRef;